// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const UbuntuIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path fill="#E95420" d="M19.44 1H5v22h14.44z" />
    <path
      fill="#fff"
      d="M8.3 17.03a1.5 1.5 0 1 0 0-2.98 1.5 1.5 0 0 0 0 2.98M14.53 13.76a1.5 1.5 0 1 0 0-2.98 1.5 1.5 0 0 0 0 2.98M11.67 19.4a3.7 3.7 0 0 1-2.48-1.9q-.62.27-1.28.16a4.9 4.9 0 0 0 4.56 3.04c-.27-.35-.42-.8-.44-1.25zM14.2 20.89a1.5 1.5 0 1 0 0-2.98 1.5 1.5 0 0 0 0 2.98M16.27 18.85a4.9 4.9 0 0 0 .24-5.74q-.27.62-.84.98a3.6 3.6 0 0 1-.12 3.64q.54.44.71 1.11M8.18 13.4h.12q.23 0 .45.05.37.09.68.28a3.6 3.6 0 0 1 2.94-1.57q0-.17.05-.34.1-.49.4-.87A4.9 4.9 0 0 0 8.2 13.4"
    />
  </svg>,
  "Ubuntu",
);
export default UbuntuIcon;
